module.exports = __webpack_public_path__ + "static/img/reservation-spep-1.afb28f1.png";